import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(html: string | null | undefined): SafeHtml {
    // Use sanitize to remove dangerous content while keeping safe HTML
    return this.sanitizer.sanitize(SecurityContext.HTML, html ?? '') || '';
  }
}
